import "./PasswordEdit.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import PasswordEditComponentController from "./PasswordEditComponentController";

export default class PasswordEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = PasswordEditComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Password/EditForm/PasswordEdit.html";
    }
}

module("mmAuth").component("mmPasswordEdit", new PasswordEditComponent());
